import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

import { LocalStorageService } from "@core/services/local-storage.service";
import { TSelectionOption } from "@core/types/selection-option.type";

import { TranslateService } from "@ngx-translate/core";
import { environment } from "@env/environment";

const LANGUAGE_STORAGE_KEY = "locale-key";
const DEFAULT_LANGUAGE = "en";

@Injectable({ providedIn: "root" })
export class LocalizationService {
  readonly language$ = new BehaviorSubject<string>(DEFAULT_LANGUAGE);
  readonly languages$ = new BehaviorSubject<TSelectionOption[]>([]);

  constructor(
    private readonly localStorage: LocalStorageService,
    private readonly translateService: TranslateService,
  ) {}

  init(): void {
    const languages = environment.availableLanguages.map(
      item => ({ id: item, name: `LANG.${item.toUpperCase()}` })
    );

    const selectedLang = this.localStorage.getItem<string>(LANGUAGE_STORAGE_KEY) ?? DEFAULT_LANGUAGE;
    const currentLanguage = languages.some(item => item.id === selectedLang)
      ? selectedLang : languages[0].id;

    this.setLang(currentLanguage);
    this.languages$.next(languages);
  }

  setLang(locale: string): void {
    this.translateService.use(locale);
    this.language$.next(locale);

    this.localStorage.setItem(LANGUAGE_STORAGE_KEY, locale);
  }
}
